import React from 'react';
import FeatureRichList from '../Common/RichList/FeatureRichList';

const Withdraw = ({setStep, step, data}) => {
	return (
		<FeatureRichList data={data || []} step={step} subClass='subClass' linkedPage setStep={setStep}/>
	);
};

export default Withdraw;
